import BaseRepository from "@/services/resources/repository";
import byNewsItem from "@/services/resources/mixins/query-by-news-item";
import byProject from "@/services/resources/mixins/query-by-project";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byNewsItem).$mix(byProject);
    }
}

export default Repository;
